export default () => {
    
    let concurrent = 0;
    let max = 2;
    
    function wayback(url, callback) {
        if (concurrent >= max) { // delay call
            setTimeout(() => wayback(url, callback), 200);
            return;
        }
        
        concurrent++;
        let apiUrl = 'https://archive.org/wayback/available';
        
        const applyArchived = json => {
            let snapshot = json['archived_snapshots'];
            if (Object.keys(snapshot).length) {
                const url = snapshot.closest.url.replace(/^http:/, 'https:');
                callback(url);
            }
        };
        
        jQuery
        .getJSON(`${apiUrl}?url=${url}&callback=?`, applyArchived)
        .done(() => concurrent--);
    }
    
    Array.from(document.querySelectorAll('article img'))
         .forEach(i => {
             if (i.src.match(/^https?:\/\/[^/]*\b(vof\.|localhost)/)) {
                 fetch(i.src)
                 .then(r => {
                     const old = i.src.replace(/^https?:\/\/[^/]*/, 'www.vof.se');
                     if (r.status === 404) {
                         wayback(old, url => i.src = url);
                     }
                 });
             }
         });
};



// WEBPACK FOOTER //
// ./scripts/util/replace404images.js